import { render, staticRenderFns } from "./splitter.vue?vue&type=template&id=2efca2ea&"
import script from "./splitter.vue?vue&type=script&lang=js&"
export * from "./splitter.vue?vue&type=script&lang=js&"
import style0 from "./splitter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports